import { render, staticRenderFns } from "./ads-preview.vue?vue&type=template&id=06168943&scoped=true"
import script from "./ads-preview.vue?vue&type=script&lang=js"
export * from "./ads-preview.vue?vue&type=script&lang=js"
import style0 from "./ads-preview.vue?vue&type=style&index=0&id=06168943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06168943",
  null
  
)

export default component.exports